module.exports = __webpack_public_path__ + "media/images/shop/photo_thumbnail3-f68db32bb708967b4b1febc25b753f86.jpg";